/**
 * External dependencies
 */

/**
 * Internal dependencies
 */

export const initialStateReducer = state => state;
export const initialInputControlState = {
  error: null,
  initialValue: '',
  isDirty: false,
  isDragEnabled: false,
  isDragging: false,
  isPressEnterToChange: false,
  value: ''
};
//# sourceMappingURL=state.js.map